export default "__VITE_ASSET__77064d61__"